import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { GasAllocationTarget } from "../models/GasAllocationTarget";

export const getGasAllocationTargets = async (
	signal?: AbortSignal,
): Promise<GasAllocationTarget[]> => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[USG].[GetGasAllocationTargets]",
		[],
		signal,
	);

	if (!resp.ok) {
		throw new Error(
			resp.message || "Error fetching the gas allocation targets",
		);
	}

	return get(resp, "data.tables.0.rows", []) as GasAllocationTarget[];
};

export const upsertGasAllocationDefaults = async (
	draft: { TargetId: number; DefaultAllocationPercent: number }[],
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "DefaultsJson", value: JSON.stringify(draft) },
	];

	const resp = await apiService.callV2(
		"[USG].[UpsertGasAllocationDefaults]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error saving the default gas shares");
	}
};
